import * as React from "react";
import { useContext } from "react";
import { faTrash } from "@fortawesome/free-solid-svg-icons/faTrash";
import { toast } from "react-toastify";
import { faTrashRestore } from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import { FtlRouteViewModel } from "../../../../ViewModel/FtlRouteViewModel";
import { StyledButton } from "../../../../../Layout/Inputs/StyledButton";
import StyledPageMenuIcon from "../../../../../Layout/PageMenu/PageMenuIcon";
import { EditProjectContext } from "../../../EditProjectContext";
import { projectUrls } from "../../../../../URL/ApplicationUrls";
import { combinedUrls } from "../../../../../URL/functions";

export default function ExpireButton({ route }: { route: FtlRouteViewModel }) {
  const { project, reloadData } = useContext(EditProjectContext);
  const expireRoute = async (expire: boolean) => {
    const request = {
      Expire: expire,
    };

    const url = combinedUrls(
      projectUrls.projectWithId(project.ProjectId).apiUrl,
      `/Expire/${route.RouteId}`
    );
    const fetchPromise = axios.post(url, request);
    const response = await toast.promise(fetchPromise, {
      pending: "Expiring Route",
      success: `Route ${route.RouteNumber} has been ${
        expire ? "expired" : "restored"
      } from project`,
      error: `Unknown error while ${expire ? "expiring" : "restoring"} Route from project`,
    });
    if (response.status !== 200) {
      throw new Error("Network response was not ok");
    }

    reloadData();
  };

  return (
    <StyledButton onClick={() => expireRoute(!route.IsExpired)} width="100%">
      {route.IsExpired ? (
        <>
          <StyledPageMenuIcon icon={faTrashRestore} />
          Restore
        </>
      ) : (
        <>
          <StyledPageMenuIcon icon={faTrash} />
          Expire
        </>
      )}
    </StyledButton>
  );
}
